const isBrowser = typeof window !== 'undefined'
export default isBrowser && window.matchMedia('(max-width: 47.9375em)').matches
